import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { getQueryParamString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  CategoryListUrlQueryParams,
  CategoryListUrlSortField,
  CategoryUrlQueryParams
} from "./urls";
import { CategoryCreateView } from "./views/CategoryCreate";
import CategoryDetailsView, { getActiveTab } from "./views/CategoryDetails";
import CategoryListComponent from "./views/CategoryList";

const CategoryDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params: CategoryUrlQueryParams = {
    ...qs,
    activeTab: getActiveTab(getQueryParamString(qs.activeTab))
  };

  return <CategoryDetailsView id={decodeURIComponent(id)} params={params} />;
};

const CategoryCreate: React.FC = () => {
  const { id } = useParams();
  return (
    <CategoryCreateView parentId={id ? decodeURIComponent(id) : undefined} />
  );
};

const CategoryList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = {
    ...asSortParams(qs, CategoryListUrlSortField)
  } as CategoryListUrlQueryParams;

  return <CategoryListComponent params={params} levels={undefined} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.categories)} />
      <Routes>
        <Route path={""} element={<CategoryList />} />
        <Route path={"/add"} element={<CategoryCreate />} />
        <Route path={":id/add"} element={<CategoryCreate />} />
        <Route path={":id"} element={<CategoryDetails />} />
      </Routes>
    </>
  );
};

export default Component;
